var map = {
	"./dinesh-singh.webp": 4458,
	"./elcano-wilson.webp": 381,
	"./fazlin-ally.webp": 1254,
	"./jose-romero.webp": 6714,
	"./muhammed-daya.webp": 7267,
	"./richard-brews.webp": 7627,
	"./salome-kgoale.webp": 6125,
	"./sean-forrester.webp": 6000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4922;